<nb-card>
  <nb-card-header>{{ isEdit ? 'Bewohner bearbeiten' : 'Bewohner hinzufügen' }}</nb-card-header>
  <nb-card-body>
    <div class="dialog-form">
      <div class="dialog-form-field">
        <label class="label">Kundennummer *</label>
        <input nbInput fullWidth [(ngModel)]="customerNumber" placeholder="Kundennummer...">
      </div>
      <div class="dialog-form-field">
        <label class="label">Einzugsdatum *</label>
        <wr-date-picker [(ngModel)]="startDate"></wr-date-picker>
      </div>
      <div class="dialog-form-field">
        <label class="label">Auszugsdatum (optional)</label>
        <wr-date-picker [(ngModel)]="endDate"></wr-date-picker>
      </div>
    </div>
    @if (error) {
      <nb-alert status="danger" closable (close)="error = null" style="margin-top: 1rem;">
        {{ error }}
      </nb-alert>
    }
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="basic" (click)="cancel()">Abbrechen</button>
    <button nbButton status="primary" (click)="submit()">{{ isEdit ? 'Speichern' : 'Hinzufügen' }}</button>
  </nb-card-footer>
</nb-card>
